export function HTMLsanitize(string) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
  }
  const reg = /[&<>"'/]/gi
  return string.replace(reg, (match) => map[match])
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}

export function isBase64(str) {
  if (str === '' || str.trim() === '') {
    return false
  }
  const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/

  return base64regex.test(str)
}

export function isBase64Url(str) {
  if (str === '' || str.trim() === '') {
    return false
  }
  const base64Urlregex = /^([0-9a-zA-Z\-_])*?$/

  return base64Urlregex.test(str)
}

export function base64Encode(unencoded) {
  const utf8Encoder = new TextEncoder()
  const bytes = utf8Encoder.encode(unencoded)
  const binString = String.fromCharCode(...bytes)
  return btoa(binString)
}

export function base64Decode(encoded) {
  const utf8Decoder = new TextDecoder()
  const binString = atob(encoded)
  const bytes = Uint8Array.from(binString, (char) => char.charCodeAt(0))
  return utf8Decoder.decode(bytes)
}

export function base64UrlEncode(unencoded) {
  const encoded = base64Encode(unencoded)
  return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export function base64UrlDecode(encoded) {
  encoded = encoded.replace(/-/g, '+').replace(/_/g, '/')
  while (encoded.length % 4) encoded += '='
  return base64Decode(encoded)
}

export function parseJwt(token) {
  // Callers assume null means "not a usable token". Anything malformed (including the literal
  // string 'undefined' left in localStorage by an aborted boot) must come back as null, not throw.
  try {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )

    return JSON.parse(jsonPayload)
  } catch (e) {
    return null
  }
}
